import { connect } from 'react-redux';
import Attachment from './';
import { downloadAttachment, revokeAttachmentUrl } from '../../actions/chatActions';

const mapDispatchToProps = dispatch => ({
  revokeAttachmentUrl: id => dispatch(revokeAttachmentUrl(id)),
  downloadAttachment: (id, isStreaming) => dispatch(downloadAttachment(id, isStreaming)),
});

export default connect(null, mapDispatchToProps)(Attachment);
